var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgSocialMedia(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Untitled") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "high-social",
    fillRule: "nonzero",
    fill: "#9e9e9e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.28,0.8 L5.63,0.8 C2.968,0.8 0.81,2.958 0.81,5.62 L0.81,5.62 L0.81,24.82 C0.81,27.482 2.968,29.64 5.63,29.64 L5.63,29.64 L9.16,29.64 C9.817,29.64 10.35,30.173 10.35,30.83 L10.35,37.9 C10.356,38.608 10.931,39.18 11.64,39.18 C12.026,39.18 12.372,39.01 12.609,38.742 L20.17,30.041 C20.389,29.789 20.711,29.631 21.069,29.631 C21.069,29.631 21.07,29.631 21.07,29.631 L34.28,29.631 C36.942,29.631 39.1,27.473 39.1,24.811 L39.1,24.811 L39.1,5.621 C39.1,2.959 36.942,0.801 34.28,0.801 L34.28,0.801 L34.28,0.8 Z M28.34,12.8 L24.74,12.8 L24.74,17.57 L28.34,17.57 C28.997,17.57 29.53,18.103 29.53,18.76 L29.53,18.76 C29.531,18.775 29.531,18.792 29.531,18.81 C29.531,19.464 29.003,19.995 28.35,20 L24.75,20 L24.75,23.6 C24.75,24.257 24.217,24.79 23.56,24.79 L23.56,24.79 C22.903,24.79 22.37,24.257 22.37,23.6 L22.37,23.6 L22.37,20 L17.57,20 L17.57,23.6 C17.57,24.257 17.037,24.79 16.38,24.79 L16.38,24.79 L16.38,24.79 C15.723,24.79 15.19,24.257 15.19,23.6 L15.19,23.6 L15.19,20 L11.57,20 C10.913,20 10.38,19.467 10.38,18.81 L10.38,18.81 L10.38,18.81 C10.38,18.153 10.913,17.62 11.57,17.62 L15.17,17.62 L15.17,12.82 L11.57,12.82 C11.57,12.82 11.57,12.82 11.57,12.82 C10.916,12.82 10.386,12.293 10.38,11.641 L10.38,11.64 C10.38,11.631 10.38,11.621 10.38,11.61 C10.38,10.953 10.913,10.42 11.57,10.42 C11.57,10.42 11.57,10.42 11.57,10.42 L15.17,10.42 L15.17,6.82 C15.17,6.163 15.703,5.63 16.36,5.63 L16.36,5.63 C17.017,5.63 17.55,6.163 17.55,6.82 L17.55,6.82 L17.55,10.42 L22.32,10.42 L22.32,6.82 C22.32,6.163 22.853,5.63 23.51,5.63 L23.51,5.63 C24.167,5.63 24.7,6.163 24.7,6.82 L24.7,6.82 L24.7,10.42 L28.3,10.42 C28.957,10.42 29.49,10.953 29.49,11.61 L29.49,11.61 L29.49,11.61 C29.49,11.616 29.49,11.624 29.49,11.631 C29.49,12.271 28.985,12.793 28.352,12.82 L28.35,12.82 L28.34,12.8 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "17.57 12.82 22.34 12.82 22.34 17.59 17.57 17.59"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialMedia);
export default __webpack_public_path__ + "static/media/socialMedia.d4a8e8a6068e3ac6f2d6f081254e57a6.svg";
export { ForwardRef as ReactComponent };